import { createNextTableContext } from '@core/table';

export const UnknownDeclarationsTableContext = createNextTableContext();
